import { useEffect } from "react";
import { X } from "lucide-react";

// Issue #43 — removed the "Methodology" entry (that route was retired,
// see App.js's route comment) and the entire "Counsel" group (the
// Counsel widget has never actually been mounted since its Phase I
// retirement, so none of Cmd/Ctrl+K, Shift+K, or Shift+1-4 ever did
// anything — this cheat-sheet was advertising dead shortcuts).
const SHORTCUTS = [
    { key: "g h", label: "Home", group: "Navigate" },
    { key: "g a", label: "All analyses", group: "Navigate" },
    { key: "g n", label: "New analysis", group: "Navigate" },
    { key: "/", label: "Focus search (on /analyses)", group: "Navigate" },
    { key: "?", label: "Open this cheat-sheet", group: "Navigate" },
];

export default function ShortcutsModal({ open, onClose }) {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => {
            if (e.key === "Escape") onClose?.();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center px-4"
            data-testid="shortcuts-modal"
            role="dialog"
            aria-modal
        >
            <div
                className="absolute inset-0 bg-ink/40 backdrop-blur-sm"
                onClick={onClose}
                aria-hidden
            />
            <div className="relative bg-paper border border-ink/15 max-w-md w-full p-7">
                <div className="flex items-start justify-between mb-5">
                    <div>
                        <div className="eyebrow mb-1">Keyboard</div>
                        <h2 className="font-serif text-[24px] leading-tight font-medium text-ink">
                            Shortcuts
                        </h2>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-1 text-ink-soft hover:text-ink transition-colors"
                        aria-label="Close"
                    >
                        <X size={16} />
                    </button>
                </div>
                <ul className="divide-y divide-ink/10">
                    {SHORTCUTS.map((s) => (
                        <li
                            key={s.key}
                            className="flex items-center justify-between py-2.5"
                            data-testid={`shortcut-${s.key.replace(/\s+/g, "-")}`}
                        >
                            <span className="text-[13px] text-ink-soft">{s.label}</span>
                            <kbd className="font-mono text-[12px] px-2 py-1 bg-paper-soft border border-ink/15 rounded-sm text-ink tabular-nums">
                                {s.key}
                            </kbd>
                        </li>
                    ))}
                </ul>
                <p className="mt-5 text-[12px] text-ink-soft/70 leading-relaxed">
                    Shortcuts are disabled while typing in any input or textarea.
                </p>
            </div>
        </div>
    );
}
